"use client";

import { useEffect } from "react";
import { resetOrphanedBodyScrollLock } from "@/lib/body-scroll-lock";

/** Corrige body/html preso com overflow:hidden após modal/sheet fechar sem limpar. */
export function PwaBodyScrollRecovery() {
  useEffect(() => {
    const recover = () => {
      resetOrphanedBodyScrollLock();
    };
    recover();
    document.addEventListener("visibilitychange", recover);
    window.addEventListener("pageshow", recover);
    return () => {
      document.removeEventListener("visibilitychange", recover);
      window.removeEventListener("pageshow", recover);
    };
  }, []);

  return null;
}
